export default __webpack_public_path__ + "static/media/thejadedugout.2c6aa221.jpg";